import {es} from './utils/translations/es';
import {en} from './utils/translations/en';
import {fr} from './utils/translations/fr';
import {de} from './utils/translations/de';
import {it} from './utils/translations/it';
import {pt} from './utils/translations/pt';
import {tr} from './utils/translations/tr';
import {jp} from './utils/translations/jp';
import {cn} from './utils/translations/cn';
import {sa} from './utils/translations/sa';

// Ready translated locale messages
export const messages = {
  en: en,
  es: es,
  fr: fr,
  de: de,
  it: it,
  pt: pt,
  tr: tr,
  jp: jp,
  cn: cn,
  sa: sa,
};

export default messages;



// WEBPACK FOOTER //
// ./src/dictionary.js